import { Controller } from 'stimulus'
import { trackEvent } from '../../src/javascripts/tracking'
let debounce = require('lodash/debounce');

export default class extends Controller {
  static targets = ['participants', 'deliveryType', 'supportType', 'search', 'book', 'form', 'theme', 'selector', 'duration', 'noResults']

  connect() {
    if (!this.hasSearchTarget) return

    this.handleSearchClick = this.handleSearchClick.bind(this)
    this.searchTarget.addEventListener('click', this.handleSearchClick)
    this.formTarget.addEventListener('submit', this.handleSearchClick)
  }

  disconnect() {
    if (!this.hasSearchTarget) return
    
    this.searchTarget.removeEventListener('click', this.handleSearchClick)
    this.formTarget.removeEventListener('submit', this.handleSearchClick)
  }

  handleSearchClick(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    if (!this.formTarget.reportValidity()) return

    this.instabook()
    window.requestAnimationFrame(() => this.scrollToThemeIndex())
  }

  instabook() {
    const params = {
      participants: Number(this.participantsTarget.value), // ensure number for PH event properties
      delivery_type: this.deliveryTypeTarget.value,
      support_type: this.supportTypeTarget.value
    }

    trackEvent('instabook_search', params)

    let anyVisible = false

    this.themeTargets.forEach(theme => {
      let variants;

      try {
        variants = JSON.parse(theme.dataset.variantsHash)
      } catch (error) {
        console.error('Failed to parse variants hash for theme:', theme, error)
        return
      }
      const theme_variant_id = variants?.[this.deliveryTypeTarget.value]?.[this.durationTarget.value]

      if ( theme_variant_id == undefined ) {
        theme.classList.add('hidden')
      } else {
        theme.classList.remove('hidden')
        anyVisible = true
      }

      const buyNow = theme.querySelector('.btn.btn-primary.btn-core')
      if (!buyNow) return

      const url = new URL(buyNow.href)
      Object.entries(params).forEach(([key, value]) => value && url.searchParams.set(key, value))
      url.searchParams.set("theme_variant_id", theme_variant_id)

      buyNow.href = url.toString()
    })

    if (!anyVisible) {
      this.noResultsTarget.classList.remove('hidden')
    } else {
      this.noResultsTarget.classList.add('hidden')
    }
  }

  scrollToThemeIndex() {
    const target = document.getElementById('themeGrid');

    if (!target) return

    const offset = 100
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset

    window.scrollTo({ top, behavior: 'smooth' })
  }
}